module.exports = __webpack_public_path__ + "img/img03.cdfd4e79.png";